import styles from './loading.module.scss';
import React, { useEffect, useState } from 'react';
import RotatingSpinner from 'components/rotating-spinner/rotating-spinner';
import { Language } from '_types/language';
import questionsData from '../../assets/random_cards.json';

type LoadingProps = {
    language: Language;
    showQuestion?: boolean;
};

const Loading: React.FC<LoadingProps> = ({ language, showQuestion }) => {
    const [randomQuestion, setRandomQuestion] = useState<string | null>(null);

    useEffect(() => {
        try {
            const idx = Math.floor(Math.random() * questionsData.length);
            setRandomQuestion(
                language === 'nb'
                    ? questionsData[idx].title
                    : questionsData[idx].english
            );
        } catch (err) {
            console.error(err);
        }
    }, []);

    return (
        <article data-testid='component-loading' className={styles.Loading}>
            {showQuestion && (
                <div className={styles.loadingQuestion}>
                    {randomQuestion ? randomQuestion : 'Loading question...'}
                </div>
            )}
            <RotatingSpinner color='black' variant='thinLarge' />
        </article>
    );
};

export default Loading;
